<template>
  <div
    class="arrow-input flex--row-center-center"
    :class="{
      'arrow-input--black': black,
      'arrow-input--focused': inputFocus,
      'arrow-input--loading': isLoading
    }"
  >
    <FormInput
      class="arrow-input__input"
      :class="{
        'arrow-input__input--black': black,
        'arrow-input__input--error': hasError
      }"
      type="email"
      noLabel
      float
      :inputId="inputId"
      :value="value"
      :placeholder="placeholder"
      autocomplete="off"
      @input="handleInput"
      @keyup.native.enter="() => $emit('submit')"
      :disabled="isLoading"
    />
    <div
      class="arrow-input__button flex--col-center-end"
      @click="handleSubmitClick"
      @focus="() => (inputFocus = true)"
      @blur="() => (inputFocus = false)"
      @mouseover="() => (inputFocus = true)"
      @mouseleave="() => (inputFocus = false)"
      type="submit"
      tabIndex="0"
    >
      <!-- <Clock
        v-if="isLoading"
        class="arrow-input__clock"
        :class="{
          'arrow-input__clock--black': black
        }"
      /> -->
      <Arrow
        class="arrow-input__arrow"
        :class="{
          'arrow-input__arrow--black': black
        }"
      />
    </div>
  </div>
</template>

<script>
import Arrow from "@/assets/arrow.svg"
// import Clock from "@/assets/clock.svg"
import FormInput from "@/components/form/FormInput"

export default {
  props: {
    black: Boolean,
    hasError: Boolean,
    inputId: String,
    isLoading: Boolean,
    placeholder: String,
    typeClass: String,
    value: String
  },

  components: { Arrow, /* Clock, */ FormInput },

  data() {
    return {
      inputFocus: false
    }
  },

  methods: {
    handleInput(val) {
      Bleach.debug.log("ArrowInput input", val)
      this.$emit("input", val)
    },

    handleSubmitClick(evt) {
      Bleach.debug.log("ArrowInput submit", evt)
      this.$emit("submit")
    }
  }
}
</script>

<style lang="scss">
.arrow-input {
  position: relative;
  border-bottom: 1.5px solid getcolour(bleach_white);

  &--black {
    border-bottom: 1.5px solid getcolour(bleach_black);
  }

  &--focused {
    .arrow-input__arrow {
      right: -10px;
    }
  }

  &--loading {
    .arrow-input__arrow {
      opacity: 0;
      transform: translateX(100%);
      //   path {
      //     animation: arrow-right-disappear 1.25s infinite ease-out;

      //     @media (prefers-reduced-motion: reduce) {
      //       animation: none;
      //     }
      //   }
    }
  }

  // .input__container-field {
  //   padding-left: 0;
  //   border: none;
  //   border-bottom: 1px solid $bleach-white;
  // }

  input {
    background: transparent;
    color: inherit;
  }

  &__input {
    flex: 0 1 auto;

    div[data-lastpass-icon-root] {
      display: none;
    }

    input::placeholder {
      color: getcolour(bleach_white);
      opacity: 0.25;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
      -webkit-text-fill-color: getcolour(bleach_white);
      -webkit-box-shadow: 0 0 0px 1000px getcolour(bleach_black) inset;
      transition: background-color 5000s ease-in-out 0s;
    }

    input:disabled {
      opacity: 0.5;
    }

    &--black {
      input::placeholder {
        color: getcolour(bleach_black);
      }

      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus {
        -webkit-text-fill-color: getcolour(bleach_black);
        -webkit-box-shadow: 0 0 0px 1000px getcolour(bleach_black) inset;
        transition: background-color 5000s ease-in-out 0s;
      }
    }
  }

  &__button {
    flex: 0 0 35px;
    cursor: pointer;
    width: 35px;
    height: 100%;
  }

  &__arrow,
  &__clock {
    transition: opacity 0.3s linear;
    height: 20px;
    width: 35px;
    fill: getcolour(bleach_white);
    stroke: getcolour(bleach_white);
    // top: 4px;
    transition: transform 0.3s ease-in, opacity 0.3s linear;

    path {
      vector-effect: non-scaling-stroke;
      stroke-width: 1px;
    }

    &--black {
      fill: getcolour(bleach_black);
      stroke: getcolour(bleach_black);
    }
  }

  &__clock {
    fill: none;

    &--black {
      fill: none;
    }
  }
}

// @keyframes arrow-right-disappear {
//   0% {
//     transform: translate3d(0, 0, 0);
//   }

//   100% {
//     transform: translate3d(240px, 0, 0);
//   }
// }
</style>
